import { numberValidator } from '../validation';
export default (random, n = 1) => {
    numberValidator(n).isInt().isPositive();
    const irwinHall = random.irwinHall(n);
    return () => {
        return irwinHall() / n;
    };
};
//# sourceMappingURL=bates.js.map